// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3xfvy5n_UW5Gir88Fpg-eB{height:100%;display:flex;flex-direction:column}._11q7V0Iag5-HZyyC7RrWXf{padding:.35714rem;height:100%}._1wRlB12n1eOUetfPPb7rX-{background:#fff;padding-top:.5rem}._3ph6EMHm_AluEmmJVTVWlp{margin:1.42857rem auto;margin-top:1.07143rem;text-align:center;display:inline-flex;justify-content:center;width:100%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topCheerersTab": "_3xfvy5n_UW5Gir88Fpg-eB",
	"topCheerersTab__content": "_11q7V0Iag5-HZyyC7RrWXf",
	"topCheerersTab__bottomBar": "_1wRlB12n1eOUetfPPb7rX-",
	"topCheerersTab__warningInfo": "_3ph6EMHm_AluEmmJVTVWlp"
};
export default ___CSS_LOADER_EXPORT___;
